import { Lightbulb } from 'lucide-react';
import { Button, Card } from '@chessmate/ui';
import type { CoachAdvice } from '@chessmate/ai-coach';
import { SpeakerButton } from './SpeakerButton.js';
import { useT } from '../i18n/useT.js';

export function CoachPanel({
  advice,
  loading,
  onAsk,
  disabled,
}: {
  advice: CoachAdvice[] | null;
  loading: boolean;
  onAsk: () => void;
  disabled: boolean;
}) {
  const { t } = useT('games');
  return (
    <Card>
      <div className="mb-2 flex items-center gap-2" data-testid="coach-header">
        <img
          src="/coach/coach.webp"
          alt=""
          data-testid="coach-avatar"
          className="h-10 w-10 rounded-full object-cover"
        />
        <h2 className="text-xl font-extrabold text-ink">Coach</h2>
      </div>
      <div className="flex flex-col gap-2">
        <Button onClick={onAsk} disabled={disabled || loading} className="min-h-[48px] !py-2 !px-3 text-sm" data-testid="coach-ask">
          <Lightbulb className="mr-1 inline" size={16} />
          {loading ? t('thinking') : t('suggest-a-move')}
        </Button>
        {advice?.length ? (
          <ul className="flex flex-col gap-2" data-testid="coach-list">
            {advice.map((a) => (
              <li key={a.san} className="rounded-xl bg-white/70 p-2" data-testid="coach-suggestion">
                <span className="font-extrabold text-berry">{a.san}</span>
                <span className="ml-2 text-sm font-semibold text-ink/80">{a.explanation}</span>
                {a.speakable && <SpeakerButton text={a.speakable} />}
              </li>
            ))}
          </ul>
        ) : null}
      </div>
    </Card>
  );
}
